import { render, staticRenderFns } from "./faka.vue?vue&type=template&id=c1e1e3e4&scoped=true"
import script from "./faka.vue?vue&type=script&lang=js"
export * from "./faka.vue?vue&type=script&lang=js"
import style0 from "./faka.vue?vue&type=style&index=0&id=c1e1e3e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1e1e3e4",
  null
  
)

export default component.exports